import { useState, useCallback } from 'react';

const STORAGE_KEY = 'tallyup-collapsed-widgets';

function loadCollapsed(): Record<string, boolean> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function useCollapsedWidgets() {
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>(loadCollapsed);

  const isCollapsed = useCallback(
    (widgetId: string) => !!collapsed[widgetId],
    [collapsed]
  );

  const toggleCollapse = useCallback((widgetId: string) => {
    setCollapsed((prev) => {
      const next = { ...prev, [widgetId]: !prev[widgetId] };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { isCollapsed, toggleCollapse };
}
